// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   GLOBAL
========================================== */
.result-section {
  padding: 15px 0 70px;
  background: #f5f7fb;
  min-height: calc(100vh - 180px);
}

.logo {
  height: 60px;
}

.page-title {
  color: #8e0b56;
  font-weight: 700;
}

/* ==========================================
   NAVBAR
========================================== */
.navbar {
  background: #fff;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
  padding: 12px 0;
}

/* ==========================================
   RESULT CARD
========================================== */
.result-card {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 5px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.result-header {
  background: #8e0b56;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 20px;
  text-align: center;
}

/* ==========================================
   TABLE
========================================== */
.table {
  margin-bottom: 0;
}

.table thead {
  background: #f3f3f3;
}

.table thead th {
  border: none;
  font-weight: 700;
  color: #444;
  text-align: center;
  vertical-align: middle;
}

.table tbody td {
  vertical-align: middle;
  text-align: center;
}

.table tbody td:nth-child(2) {
  text-align: left;
  font-weight: 600;
}

.table-hover tbody tr:hover {
  background: #faf4f8;
}

/* ==========================================
   STATUS ICONS
========================================== */
.fa-check {
  color: #28a745;
  font-size: 20px;
}

.fa-times {
  color: #dc3545;
  font-size: 20px;
}

/* ==========================================
   BUTTONS
========================================== */
.btn-primary {
  background: #8e0b56;
  border-color: #8e0b56;
}

.btn-primary:hover {
  background: #700844;
  border-color: #700844;
}

.btn-outline-primary {
  color: #8e0b56;
  border-color: #8e0b56;
}

.btn-outline-primary:hover {
  background: #8e0b56;
  color: #fff;
}

/* ==========================================
   FOOTER
========================================== */
.footer {
  background: #10243f;
  color: #fff;
}

.footer-logo {
  height: 65px;
  background: #fff;
  padding: 8px;
  border-radius: 6px;
}

.footer h5 {
  color: #fff;
  margin-bottom: 15px;
}

.footer p {
  color: rgba(255, 255, 255, 0.8);
}

.copyright {
  color: rgba(255, 255, 255, 0.7);
}

.social-icons a {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  color: #fff;
  margin-left: 8px;
  transition: 0.3s;
}

.social-icons a:hover {
  background: #8e0b56;
  text-decoration: none;
}

/* ==========================================
   MOBILE
========================================== */
@media (max-width: 991px) {
  .logo {
    height: 50px;
  }
  .page-title {
    font-size: 28px;
  }
  .result-header {
    font-size: 18px;
  }
  .navbar .d-flex {
    gap: 6px;
  }
}
@media (max-width: 767px) {
  .result-section {
    padding: 30px 0 50px;
  }
  .logo {
    height: 42px;
  }
  .page-title {
    font-size: 24px;
  }
  .table {
    min-width: 700px;
  }
  .footer {
    text-align: center;
  }
  .footer-logo {
    margin-bottom: 20px;
  }
  .social-icons {
    margin-top: 15px;
  }
  .social-icons a {
    margin: 0 5px;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlc3VsdC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7NENBQUE7QUFJQTtFQUNJLG9CQUFBO0VBQ0EsbUJBQUE7RUFDQSwrQkFBQTtBQUFKOztBQUdBO0VBQ0ksWUFBQTtBQUFKOztBQUdBO0VBQ0ksY0FBQTtFQUNBLGdCQUFBO0FBQUo7O0FBSUE7OzRDQUFBO0FBSUE7RUFDSSxnQkFBQTtFQUNBLDBDQUFBO0VBQ0EsZUFBQTtBQUZKOztBQVNBOzs0Q0FBQTtBQUlBO0VBQ0ksWUFBQTtFQUNBLG1CQUFBO0VBQ0EsZ0JBQUE7RUFDQSw2QkFBQTtFQUNBLDBDQUFBO0FBUEo7O0FBVUE7RUFDSSxtQkFBQTtFQUNBLFdBQUE7RUFDQSxlQUFBO0VBQ0EsZ0JBQUE7RUFDQSxpQkFBQTtFQUNBLGtCQUFBO0FBUEo7O0FBVUE7OzRDQUFBO0FBSUE7RUFDSSxnQkFBQTtBQVJKOztBQVdBO0VBQ0ksbUJBQUE7QUFSSjs7QUFXQTtFQUNJLFlBQUE7RUFDQSxnQkFBQTtFQUNBLFdBQUE7RUFDQSxrQkFBQTtFQUNBLHNCQUFBO0FBUko7O0FBV0E7RUFDSSxzQkFBQTtFQUNBLGtCQUFBO0FBUko7O0FBV0E7RUFDSSxnQkFBQTtFQUNBLGdCQUFBO0FBUko7O0FBV0E7RUFDSSxtQkFBQTtBQVJKOztBQVlBOzs0Q0FBQTtBQUlBO0VBQ0ksY0FBQTtFQUNBLGVBQUE7QUFWSjs7QUFhQTtFQUNJLGNBQUE7RUFDQSxlQUFBO0FBVko7O0FBYUE7OzRDQUFBO0FBSUE7RUFDSSxtQkFBQTtFQUNBLHFCQUFBO0FBWEo7O0FBY0E7RUFDSSxtQkFBQTtFQUNBLHFCQUFBO0FBWEo7O0FBY0E7RUFDSSxjQUFBO0VBQ0EscUJBQUE7QUFYSjs7QUFjQTtFQUNJLG1CQUFBO0VBQ0EsV0FBQTtBQVhKOztBQWNBOzs0Q0FBQTtBQUlBO0VBQ0ksbUJBQUE7RUFDQSxXQUFBO0FBWko7O0FBZUE7RUFDSSxZQUFBO0VBQ0EsZ0JBQUE7RUFDQSxZQUFBO0VBQ0Esa0JBQUE7QUFaSjs7QUFlQTtFQUNJLFdBQUE7RUFDQSxtQkFBQTtBQVpKOztBQWVBO0VBQ0ksK0JBQUE7QUFaSjs7QUFlQTtFQUNJLCtCQUFBO0FBWko7O0FBZUE7RUFDSSxXQUFBO0VBQ0EsWUFBQTtFQUNBLG9CQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtFQUNBLHFDQUFBO0VBQ0Esa0JBQUE7RUFDQSxXQUFBO0VBQ0EsZ0JBQUE7RUFDQSxnQkFBQTtBQVpKOztBQWVBO0VBQ0ksbUJBQUE7RUFDQSxxQkFBQTtBQVpKOztBQWVBOzs0Q0FBQTtBQUlBO0VBRUE7SUFDSSxZQUFBO0VBZEY7RUFpQkY7SUFDSSxlQUFBO0VBZkY7RUFrQkY7SUFDSSxlQUFBO0VBaEJGO0VBbUJGO0lBQ0ksUUFBQTtFQWpCRjtBQUNGO0FBcUJBO0VBRUE7SUFDSSxvQkFBQTtFQXBCRjtFQXVCRjtJQUNJLFlBQUE7RUFyQkY7RUF3QkY7SUFDSSxlQUFBO0VBdEJGO0VBeUJGO0lBQ0ksZ0JBQUE7RUF2QkY7RUEwQkY7SUFDSSxrQkFBQTtFQXhCRjtFQTJCRjtJQUNJLG1CQUFBO0VBekJGO0VBNEJGO0lBQ0ksZ0JBQUE7RUExQkY7RUE2QkY7SUFDSSxhQUFBO0VBM0JGO0FBQ0YiLCJmaWxlIjoicmVzdWx0LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4gICBHTE9CQUxcbj09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PSAqL1xuXG4ucmVzdWx0LXNlY3Rpb257XG4gICAgcGFkZGluZzoxNXB4IDAgNzBweDtcbiAgICBiYWNrZ3JvdW5kOiNmNWY3ZmI7XG4gICAgbWluLWhlaWdodDpjYWxjKDEwMHZoIC0gMTgwcHgpO1xufVxuXG4ubG9nb3tcbiAgICBoZWlnaHQ6NjBweDtcbn1cblxuLnBhZ2UtdGl0bGV7XG4gICAgY29sb3I6IzhlMGI1NjtcbiAgICBmb250LXdlaWdodDo3MDA7XG5cbn1cblxuLyogPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4gICBOQVZCQVJcbj09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PSAqL1xuXG4ubmF2YmFye1xuICAgIGJhY2tncm91bmQ6I2ZmZjtcbiAgICBib3gtc2hhZG93OjAgMnB4IDE1cHggcmdiYSgwLDAsMCwuMDgpO1xuICAgIHBhZGRpbmc6MTJweCAwO1xufVxuXG4vLyAubmF2YmFyIC5idG57XG4vLyAgICAgYm9yZGVyLXJhZGl1czozMHB4O1xuLy8gfVxuXG4vKiA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiAgIFJFU1VMVCBDQVJEXG49PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT0gKi9cblxuLnJlc3VsdC1jYXJke1xuICAgIGJvcmRlcjpub25lO1xuICAgIGJvcmRlci1yYWRpdXM6MTZweDtcbiAgICBvdmVyZmxvdzpoaWRkZW47XG4gICAgbWFyZ2luLWJvdHRvbTo1cHggIWltcG9ydGFudDtcbiAgICBib3gtc2hhZG93OjAgOHB4IDI0cHggcmdiYSgwLDAsMCwuMDgpO1xufVxuXG4ucmVzdWx0LWhlYWRlcntcbiAgICBiYWNrZ3JvdW5kOiM4ZTBiNTY7XG4gICAgY29sb3I6I2ZmZjtcbiAgICBmb250LXNpemU6MjBweDtcbiAgICBmb250LXdlaWdodDo2MDA7XG4gICAgcGFkZGluZzo4cHggMjBweDtcbiAgICB0ZXh0LWFsaWduOmNlbnRlcjtcbn1cblxuLyogPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4gICBUQUJMRVxuPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09ICovXG5cbi50YWJsZXtcbiAgICBtYXJnaW4tYm90dG9tOjA7XG59XG5cbi50YWJsZSB0aGVhZHtcbiAgICBiYWNrZ3JvdW5kOiNmM2YzZjM7XG59XG5cbi50YWJsZSB0aGVhZCB0aHtcbiAgICBib3JkZXI6bm9uZTtcbiAgICBmb250LXdlaWdodDo3MDA7XG4gICAgY29sb3I6IzQ0NDtcbiAgICB0ZXh0LWFsaWduOmNlbnRlcjtcbiAgICB2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7XG59XG5cbi50YWJsZSB0Ym9keSB0ZHtcbiAgICB2ZXJ0aWNhbC1hbGlnbjptaWRkbGU7XG4gICAgdGV4dC1hbGlnbjpjZW50ZXI7XG59XG5cbi50YWJsZSB0Ym9keSB0ZDpudGgtY2hpbGQoMil7XG4gICAgdGV4dC1hbGlnbjpsZWZ0O1xuICAgIGZvbnQtd2VpZ2h0OjYwMDtcbn1cblxuLnRhYmxlLWhvdmVyIHRib2R5IHRyOmhvdmVye1xuICAgIGJhY2tncm91bmQ6I2ZhZjRmODtcbn1cblxuXG4vKiA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiAgIFNUQVRVUyBJQ09OU1xuPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09ICovXG5cbi5mYS1jaGVja3tcbiAgICBjb2xvcjojMjhhNzQ1O1xuICAgIGZvbnQtc2l6ZToyMHB4O1xufVxuXG4uZmEtdGltZXN7XG4gICAgY29sb3I6I2RjMzU0NTtcbiAgICBmb250LXNpemU6MjBweDtcbn1cblxuLyogPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4gICBCVVRUT05TXG49PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT0gKi9cblxuLmJ0bi1wcmltYXJ5e1xuICAgIGJhY2tncm91bmQ6IzhlMGI1NjtcbiAgICBib3JkZXItY29sb3I6IzhlMGI1Njtcbn1cblxuLmJ0bi1wcmltYXJ5OmhvdmVye1xuICAgIGJhY2tncm91bmQ6IzcwMDg0NDtcbiAgICBib3JkZXItY29sb3I6IzcwMDg0NDtcbn1cblxuLmJ0bi1vdXRsaW5lLXByaW1hcnl7XG4gICAgY29sb3I6IzhlMGI1NjtcbiAgICBib3JkZXItY29sb3I6IzhlMGI1Njtcbn1cblxuLmJ0bi1vdXRsaW5lLXByaW1hcnk6aG92ZXJ7XG4gICAgYmFja2dyb3VuZDojOGUwYjU2O1xuICAgIGNvbG9yOiNmZmY7XG59XG5cbi8qID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuICAgRk9PVEVSXG49PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT0gKi9cblxuLmZvb3RlcntcbiAgICBiYWNrZ3JvdW5kOiMxMDI0M2Y7XG4gICAgY29sb3I6I2ZmZjtcbn1cblxuLmZvb3Rlci1sb2dve1xuICAgIGhlaWdodDo2NXB4O1xuICAgIGJhY2tncm91bmQ6I2ZmZjtcbiAgICBwYWRkaW5nOjhweDtcbiAgICBib3JkZXItcmFkaXVzOjZweDtcbn1cblxuLmZvb3RlciBoNXtcbiAgICBjb2xvcjojZmZmO1xuICAgIG1hcmdpbi1ib3R0b206MTVweDtcbn1cblxuLmZvb3RlciBwe1xuICAgIGNvbG9yOnJnYmEoMjU1LDI1NSwyNTUsLjgpO1xufVxuXG4uY29weXJpZ2h0e1xuICAgIGNvbG9yOnJnYmEoMjU1LDI1NSwyNTUsLjcpO1xufVxuXG4uc29jaWFsLWljb25zIGF7XG4gICAgd2lkdGg6NDBweDtcbiAgICBoZWlnaHQ6NDBweDtcbiAgICBkaXNwbGF5OmlubGluZS1mbGV4O1xuICAgIGFsaWduLWl0ZW1zOmNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6Y2VudGVyO1xuICAgIGJhY2tncm91bmQ6cmdiYSgyNTUsMjU1LDI1NSwuMTIpO1xuICAgIGJvcmRlci1yYWRpdXM6NTAlO1xuICAgIGNvbG9yOiNmZmY7XG4gICAgbWFyZ2luLWxlZnQ6OHB4O1xuICAgIHRyYW5zaXRpb246LjNzO1xufVxuXG4uc29jaWFsLWljb25zIGE6aG92ZXJ7XG4gICAgYmFja2dyb3VuZDojOGUwYjU2O1xuICAgIHRleHQtZGVjb3JhdGlvbjpub25lO1xufVxuXG4vKiA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbiAgIE1PQklMRVxuPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09ICovXG5cbkBtZWRpYShtYXgtd2lkdGg6OTkxcHgpe1xuXG4ubG9nb3tcbiAgICBoZWlnaHQ6NTBweDtcbn1cblxuLnBhZ2UtdGl0bGV7XG4gICAgZm9udC1zaXplOjI4cHg7XG59XG5cbi5yZXN1bHQtaGVhZGVye1xuICAgIGZvbnQtc2l6ZToxOHB4O1xufVxuXG4ubmF2YmFyIC5kLWZsZXh7XG4gICAgZ2FwOjZweDtcbn1cblxufVxuXG5AbWVkaWEobWF4LXdpZHRoOjc2N3B4KXtcblxuLnJlc3VsdC1zZWN0aW9ue1xuICAgIHBhZGRpbmc6MzBweCAwIDUwcHg7XG59XG5cbi5sb2dve1xuICAgIGhlaWdodDo0MnB4O1xufVxuXG4ucGFnZS10aXRsZXtcbiAgICBmb250LXNpemU6MjRweDtcbn1cblxuLnRhYmxle1xuICAgIG1pbi13aWR0aDo3MDBweDtcbn1cblxuLmZvb3RlcntcbiAgICB0ZXh0LWFsaWduOmNlbnRlcjtcbn1cblxuLmZvb3Rlci1sb2dve1xuICAgIG1hcmdpbi1ib3R0b206MjBweDtcbn1cblxuLnNvY2lhbC1pY29uc3tcbiAgICBtYXJnaW4tdG9wOjE1cHg7XG59XG5cbi5zb2NpYWwtaWNvbnMgYXtcbiAgICBtYXJnaW46MCA1cHg7XG59XG5cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/website/result/result.component.scss"],"names":[],"mappings":"AAAA;;4CAAA;AAIA;EACI,oBAAA;EACA,mBAAA;EACA,+BAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,cAAA;EACA,gBAAA;AAAJ;;AAIA;;4CAAA;AAIA;EACI,gBAAA;EACA,0CAAA;EACA,eAAA;AAFJ;;AASA;;4CAAA;AAIA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,0CAAA;AAPJ;;AAUA;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUA;;4CAAA;AAIA;EACI,gBAAA;AARJ;;AAWA;EACI,mBAAA;AARJ;;AAWA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AARJ;;AAWA;EACI,sBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,gBAAA;EACA,gBAAA;AARJ;;AAWA;EACI,mBAAA;AARJ;;AAYA;;4CAAA;AAIA;EACI,cAAA;EACA,eAAA;AAVJ;;AAaA;EACI,cAAA;EACA,eAAA;AAVJ;;AAaA;;4CAAA;AAIA;EACI,mBAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,mBAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,cAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,mBAAA;EACA,WAAA;AAXJ;;AAcA;;4CAAA;AAIA;EACI,mBAAA;EACA,WAAA;AAZJ;;AAeA;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAZJ;;AAeA;EACI,WAAA;EACA,mBAAA;AAZJ;;AAeA;EACI,+BAAA;AAZJ;;AAeA;EACI,+BAAA;AAZJ;;AAeA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAZJ;;AAeA;EACI,mBAAA;EACA,qBAAA;AAZJ;;AAeA;;4CAAA;AAIA;EAEA;IACI,YAAA;EAdF;EAiBF;IACI,eAAA;EAfF;EAkBF;IACI,eAAA;EAhBF;EAmBF;IACI,QAAA;EAjBF;AACF;AAqBA;EAEA;IACI,oBAAA;EApBF;EAuBF;IACI,YAAA;EArBF;EAwBF;IACI,eAAA;EAtBF;EAyBF;IACI,gBAAA;EAvBF;EA0BF;IACI,kBAAA;EAxBF;EA2BF;IACI,mBAAA;EAzBF;EA4BF;IACI,gBAAA;EA1BF;EA6BF;IACI,aAAA;EA3BF;AACF;AACA,grNAAgrN","sourcesContent":["/* ==========================================\n   GLOBAL\n========================================== */\n\n.result-section{\n    padding:15px 0 70px;\n    background:#f5f7fb;\n    min-height:calc(100vh - 180px);\n}\n\n.logo{\n    height:60px;\n}\n\n.page-title{\n    color:#8e0b56;\n    font-weight:700;\n\n}\n\n/* ==========================================\n   NAVBAR\n========================================== */\n\n.navbar{\n    background:#fff;\n    box-shadow:0 2px 15px rgba(0,0,0,.08);\n    padding:12px 0;\n}\n\n// .navbar .btn{\n//     border-radius:30px;\n// }\n\n/* ==========================================\n   RESULT CARD\n========================================== */\n\n.result-card{\n    border:none;\n    border-radius:16px;\n    overflow:hidden;\n    margin-bottom:5px !important;\n    box-shadow:0 8px 24px rgba(0,0,0,.08);\n}\n\n.result-header{\n    background:#8e0b56;\n    color:#fff;\n    font-size:20px;\n    font-weight:600;\n    padding:8px 20px;\n    text-align:center;\n}\n\n/* ==========================================\n   TABLE\n========================================== */\n\n.table{\n    margin-bottom:0;\n}\n\n.table thead{\n    background:#f3f3f3;\n}\n\n.table thead th{\n    border:none;\n    font-weight:700;\n    color:#444;\n    text-align:center;\n    vertical-align:middle;\n}\n\n.table tbody td{\n    vertical-align:middle;\n    text-align:center;\n}\n\n.table tbody td:nth-child(2){\n    text-align:left;\n    font-weight:600;\n}\n\n.table-hover tbody tr:hover{\n    background:#faf4f8;\n}\n\n\n/* ==========================================\n   STATUS ICONS\n========================================== */\n\n.fa-check{\n    color:#28a745;\n    font-size:20px;\n}\n\n.fa-times{\n    color:#dc3545;\n    font-size:20px;\n}\n\n/* ==========================================\n   BUTTONS\n========================================== */\n\n.btn-primary{\n    background:#8e0b56;\n    border-color:#8e0b56;\n}\n\n.btn-primary:hover{\n    background:#700844;\n    border-color:#700844;\n}\n\n.btn-outline-primary{\n    color:#8e0b56;\n    border-color:#8e0b56;\n}\n\n.btn-outline-primary:hover{\n    background:#8e0b56;\n    color:#fff;\n}\n\n/* ==========================================\n   FOOTER\n========================================== */\n\n.footer{\n    background:#10243f;\n    color:#fff;\n}\n\n.footer-logo{\n    height:65px;\n    background:#fff;\n    padding:8px;\n    border-radius:6px;\n}\n\n.footer h5{\n    color:#fff;\n    margin-bottom:15px;\n}\n\n.footer p{\n    color:rgba(255,255,255,.8);\n}\n\n.copyright{\n    color:rgba(255,255,255,.7);\n}\n\n.social-icons a{\n    width:40px;\n    height:40px;\n    display:inline-flex;\n    align-items:center;\n    justify-content:center;\n    background:rgba(255,255,255,.12);\n    border-radius:50%;\n    color:#fff;\n    margin-left:8px;\n    transition:.3s;\n}\n\n.social-icons a:hover{\n    background:#8e0b56;\n    text-decoration:none;\n}\n\n/* ==========================================\n   MOBILE\n========================================== */\n\n@media(max-width:991px){\n\n.logo{\n    height:50px;\n}\n\n.page-title{\n    font-size:28px;\n}\n\n.result-header{\n    font-size:18px;\n}\n\n.navbar .d-flex{\n    gap:6px;\n}\n\n}\n\n@media(max-width:767px){\n\n.result-section{\n    padding:30px 0 50px;\n}\n\n.logo{\n    height:42px;\n}\n\n.page-title{\n    font-size:24px;\n}\n\n.table{\n    min-width:700px;\n}\n\n.footer{\n    text-align:center;\n}\n\n.footer-logo{\n    margin-bottom:20px;\n}\n\n.social-icons{\n    margin-top:15px;\n}\n\n.social-icons a{\n    margin:0 5px;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
